import { transport } from 'config/transport';

export function callApiExportPaymentSummariesByMonth(yearMonth) {
    return transport.get(`/mamnon/thuhocsinh/monthlyReport`, { params: { yearMonth }, responseType: 'blob' });
}
